export const audit = [
  "Select all",
  "Absences",
  "Care Plans",
  "DoLS",
  "Falls",
  "Infections",
  "Incidents",
  "Interventions",
  "Risks",
  "Medications",
  "Visit Analysis",
];
